import React from "react";
import { UserFeedsType } from "../../types";
import { convertTimestamp } from "../../utils/timeConverter";
import { Link } from "react-router-dom";
import { ipfsGatewayImage } from "../../utils/ipfsGatewayImage";
import { CiUser } from "react-icons/ci";
import { useSelector } from "react-redux";

type UserFeedMenuProps = {
  userFeed: UserFeedsType | undefined;
};
const UserFeedMenu: React.FC<UserFeedMenuProps> = ({ userFeed }) => {
  const PostTime = convertTimestamp(userFeed?.createdAt);
  const user = useSelector((state: any) => state.user.userDetails);
  // const profilePics = userFeed?.creator.ecobookProfile?.profileImage;
  const add = "+ad4e_nj";
  // const profilePics = userFeed?.creator?.ecobookProfile?.profileImage;
  let _pImage: string  | null = "";

  if (
    userFeed?.creator &&
    userFeed.creator.ecobookProfile &&
    userFeed.creator.ecobookProfile.profileImage !== null
  ) {
    const profileImage = userFeed.creator?.ecobookProfile?.profileImage;

    if (profileImage !== null && profileImage !== undefined) {
      _pImage = profileImage;
    }
  }

  return (
    <div className="flex w-[70%] gap-2 mb-2 font-Poppins">
      {userFeed?.creator.ecobookProfile &&
      userFeed?.creator.ecobookProfile?.profileImage ? (
        <img
          src={ipfsGatewayImage(_pImage!)}
          alt=""
          className="w-10 h-10 rounded-full"
        />
      ) : (
        <div className="w-10 h-10 bg-slate-100 flex items-center justify-center rounded-full">
          <CiUser size={20} />
        </div>
      )}
      <div className="flex h-9 flex-col w-[70%]">
        {userFeed?.creator.id === undefined  && `${user?.firstName} ${user?.lastName}`}
        <Link to={`/ecobook/profile/${userFeed?.creator.id}${add}`}>
          <div className="text-[#222] font-medium text-xs">
            {`${userFeed?.creator.firstName} ${userFeed?.creator.lastName}`}
          </div>
        </Link>
        <div className="flex gap-1 items-center font-light">
          {/* <div className="rounded-sm bg-[#2157590D] py-[2px] px-1 flex justify-center items-center lg:text-[10px] text-[8px] text-midGreen">
            {"Public"}
          </div> */}
          <div className="text-[11px] p-[2px] text-CoolGrey ">{PostTime}</div>
        </div>
      </div>
    </div>
  );
};

export default UserFeedMenu;
